export default function MenuBar() {
    return (
        <div>
            <h1>Côté cour 🥗🥂</h1>

            <div className="info-container">
                <img width='300' src="images/cotecour.jpg" alt="Sam & Nina dans la cour" className="info-photo" />
                <p>On s'occupe du verre d'accueil, des amuses-bouches et du couscous. Pour le reste, on compte sur vous 😉</p>
                <p>Un barbecue à votre disposition en libre-service, <br />
                    pour cuire la viande que vous pouvez apporter.</p>
                <p>Côté bar, nous avons prévu des bieres au fut, vin rouge, vin blanc, eau et sirop.<br />
                    N'hésitez pas à apporter vos boissons préférées pour diversifier le bar.</p>
                <p>Il n'y aura pas de personnel. <br />
                    Afin que tout le monde puisse profiter de la fête, un espace vaisselle sera mis à disposition.</p>
            </div>
        </div>
    );
}



            /* <p>L'apéro ou le dessert (automatique selon le choix)</p> */
            /* <p>Nous proposons des wraps et du couscous pour le repas
                Un barbecue à votre disposition en libre-service, <br/>
            pensez à apporter votre viande.</p> */

            /* <p>On s'occupe du verre d'accueil, des amuses-bouches et du couscous. Pour le reste, on compte sur vous 😉</p>
<p>Un barbecue à votre disposition en libre-service, <br/>
            pour cuire la viande que vous pouvez apporter.</p>
            <p>Côté bar, nous avons prévu des bieres au fut, vin rouge, vin blanc, eau et sirop.<br/>
            N'hésitez pas à apporter vos boissons préférées pour diversifier le bar.</p>
            <p>Il n'y aura pas de personnel. <br/>
            Afin que tout le monde puisse profiter de la fête, un espace vaisselle sera mis à disposition.</p> */
            /* <p>Nous proposons :<br />
                Un bbq en libre-service pour vos viandes<br />
                <br />
               </p> */
